import { AvatarProps, Stack, Typography, TypographyProps } from '@mui/material';
import { mapCurrencyToFullName } from '@razz-team/utils';
import { AvatarCurrency } from '../Avatar/AvatarCurrency';

export interface CurrencyProps extends TypographyProps {
  currency: string;
  withAvatar?: boolean;
  avatarSize?: AvatarProps['size'];
}

export function Currency({ currency, withAvatar, avatarSize, ...props }: CurrencyProps) {
  const typography = (
    <Typography {...props}>{`${currency} • ${mapCurrencyToFullName(currency)}`}</Typography>
  );

  if (!withAvatar) return typography;

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <AvatarCurrency currency={currency} size={avatarSize} />
      {typography}
    </Stack>
  );
}
